import { ApiManager } from "../api/ApiManager";
import { IPaginatedMicrocycles, IMicrocycle, IUserFitnessPlan } from "../containers/FitnessPlan/FitnessTemplate/interface";
import * as ActionTypes from "./ActionTypes";
import { IPaginationParams } from "../containers/FitnessPlan/AllFitnessPlans/interface";
import { IUserFitnessPlanRequestParams, IUserFitnessManagedPlanParams } from "../containers/Patient/Transform/interface";


export class UserFitnessActions {
    static fetchUserFitnessPlan(requestParams: IUserFitnessPlanRequestParams): Promise<IUserFitnessPlan> {
        return ApiManager.getUserFitnessApis().fetchUserFitnessPlan(requestParams);
    }

    static fetchMicrocyleById(microcyleId: number): Promise<IPaginatedMicrocycles> {
        return ApiManager.getUserFitnessApis().fetchMicrocyleById(microcyleId);
    }

    static fetchAllExercises(dispatch?: any) {
        ApiManager.getOrionApis().fetchAllExercises().then(exercises => {
            dispatch({
                type: ActionTypes.SAVE_EXERCISES, exercises
            })
        })
    }

    static saveFitnessTemplate(requestBody: IMicrocycle): Promise<any> {
        return ApiManager.getUserFitnessApis().saveFitnessTemplate(requestBody);
    }

    static fetchAllFitnessPlans = (params: { [key: string]: { value: string | number, query: string } }, paginationParams: IPaginationParams) => {
        return ApiManager.getUserFitnessApis().fetchAllFitnessPlans(params, paginationParams);
    }

    static assignFitnessPlan = (requestParams: IUserFitnessPlanRequestParams, selectedPlanId: number) => {
        return ApiManager.getUserFitnessApis().assignFitnessPlan(requestParams, selectedPlanId);
    }

    static fetchUserFitnessManagedPlan = (requestParams: IUserFitnessManagedPlanParams) => {
        return ApiManager.getUserFitnessApis().fetchUserFitnessManagedPlan(requestParams);
    }

    static setUserFitnessPlan(userFitnessPlan: any, userFitnessPlanStartDate: any, userProfile: any, isPublishedPlan: boolean, dispatch: any) {
        dispatch({
            type: ActionTypes.SET_USER_FITNESS_PLAN_DETAILS,
            userFitnessPlan,
            userFitnessPlanStartDate,
            userProfile,
            isPublishedPlan
        })
    }

    static publishUserFitnessPlan = (planId: number) => {
        return ApiManager.getUserFitnessApis().publishUserFitnessPlan(planId);
    }

    static deleteUserFitnessPlan = (planId: number) => {
        return ApiManager.getUserFitnessApis().deleteUserFitnessPlan(planId);
    }

    static savePublishedUserFitnessPlan = (reqBody: IUserFitnessPlan) => {
        return ApiManager.getUserFitnessApis().savePublishedUserFitnessPlan(reqBody);
    }
}